/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';
import Backgrid from 'backgrid';

import formatAsDollars from '../../util/formatAsDollars';

const DollarFormatter = function (options) {
  // _.extend(this, this.defaults, options || {});
  Object.assign(this, this.defaults, options || {});

  if (this.decimals < 0 || this.decimals > 20) {
    throw new RangeError('decimals must be between 0 and 20');
  }
};

DollarFormatter.prototype = new Backgrid.CellFormatter();
Object.assign(DollarFormatter.prototype, {
  defaults: {
    decimals: 2,
    decimalSeparator: '.',
    orderSeparator: ',',
  },

  fromRaw(number, model) {
    if (_.isNull(number) || _.isUndefined(number) || _.isNaN(number) || number === '') {
      return '--';
    }
    number = parseFloat(number);
    return formatAsDollars(number);
  },

  toRaw(formattedData, model) {
    formattedData = formattedData.trim();

    if (formattedData === '' || formattedData === '--') {
      return null;
    }

    let isNegative = false;

    // if(formattedData.substring(0, 1) === '(') {
    //   formattedData = formattedData.substring(1);
    //   formattedData = formattedData.substring(0, formattedData.length - 2);
    //   isNegative = true;
    // }

    if (formattedData.substring(0, 1) === '-') {
      formattedData = formattedData.substring(1);
      isNegative = true;
    }

    let rawData = '';

    formattedData = formattedData.substring(1);

    const thousands = formattedData.split(this.orderSeparator);
    for (let i = 0; i < thousands.length; i++) {
      rawData += thousands[i];
    }

    const decimalParts = rawData.split(this.decimalSeparator);
    rawData = '';
    for (let j = 0; j < decimalParts.length; j++) {
      // eslint-disable-next-line prefer-template
      rawData += decimalParts[j] + '.';
    }

    if (rawData[rawData.length - 1] === '.') {
      rawData = rawData.slice(0, rawData.length - 1);
    }

    const result = (rawData * 1).toFixed(~~this.decimals) * 1;
    if (_.isNumber(result) && !_.isNaN(result)) {
      if (isNegative) {
        return -result;
      }
      return result;
    }
  },
});

const DollarCell = Backgrid.NumberCell.extend({
  className: 'dollar-cell',

  formatter: DollarFormatter,
});

export default DollarCell;
